import {
    CommunicationProtocol,
    IStreamingProvider,
    IStreamingProviderFactory
} from '@honeybook/core';
import { WebWebsocketStreamingProvider } from './websocket/web-websocket-streaming.provider';
import { IWebsocketService } from './websocket/websocket.types';

type WebStreamingProviderFactoryOptions = {
    webSocketsService: IWebsocketService;
};

export class WebStreamingProviderFactory implements IStreamingProviderFactory {
    private readonly webSocketsService: IWebsocketService;

    constructor({ webSocketsService }: WebStreamingProviderFactoryOptions) {
        this.webSocketsService = webSocketsService;
    }

    async createProvider<T>(
        protocol: CommunicationProtocol
    ): Promise<IStreamingProvider<T>> {
        switch (protocol.type) {
            case 'websocket': {
                const data = protocol.data as any; // Will be properly typed once defined in core
                await this.webSocketsService.waitForAuthenticated;
                return new WebWebsocketStreamingProvider<T>({
                    webSocketsService: this.webSocketsService,
                    roomId: data.room_id,
                    userId: data.user_id
                });
            }
            default:
                throw new Error(`Unsupported protocol type: ${protocol.type}`);
        }
    }
}
